import { createParseDurationCache } from "./createParseDurationCache.js";
import { parseDurationHHMM } from "./parseDurationHHMM.js";
import { parseDurationHHMMSS } from "./parseDurationHHMMSS.js";
import { parseDurationWithNoGroups } from "./parseDurationNoGroups.js";
const { getValue, setValue } = createParseDurationCache();
function parseDuration(rawDisplayValue, format) {
  const displayValue = rawDisplayValue.trim();
  const cachedValue = getValue(displayValue, format);
  if (cachedValue) return cachedValue;
  const result = computeResult(displayValue, format);
  setValue(displayValue, format, result);
  return result;
}
function computeResult(displayValue, format) {
  switch (format) {
    case "hh":
    case "mm":
    case "ss":
      return parseDurationWithNoGroups(displayValue, format);
    case "hh:mm":
      return parseDurationHHMM(displayValue);
    case "hh:mm:ss":
      return parseDurationHHMMSS(displayValue);
  }
}
export {
  parseDuration
};
//# sourceMappingURL=parseDuration.js.map
